import type { ButtonHTMLAttributes } from "react";
import { cn } from "../tokens";
type Variant = "primary"|"ghost"|"outline";
interface Props extends ButtonHTMLAttributes<HTMLButtonElement> { variant?: Variant; }
const BASE = "inline-flex items-center gap-2 rounded px-3 py-1.5 text-sm font-medium transition-colors disabled:opacity-40 disabled:pointer-events-none";
const VARIANT: Record<Variant,string> = {
  primary: "bg-[var(--color-brand)] text-black hover:opacity-90",
  ghost:   "text-[var(--color-on-surface-variant)] hover:bg-[var(--color-surface-variant)] hover:text-[var(--color-on-surface)]",
  outline: "border border-[var(--color-border)] text-[var(--color-on-surface)] hover:bg-[var(--color-surface-variant)]",
};
export function Button({ variant="ghost", className, ...rest }: Props) {
  return <button {...rest} className={cn(BASE, VARIANT[variant], className)} />;
}
